/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Pick_TitleInputs */

const en_landing_how_pick_title = /** @type {(inputs: Landing_How_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time`)
};

const pl_landing_how_pick_title = /** @type {(inputs: Landing_How_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz termin`)
};

/**
* | output |
* | --- |
* | "Pick a time" |
*
* @param {Landing_How_Pick_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_pick_title = /** @type {((inputs?: Landing_How_Pick_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Pick_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_pick_title(inputs)
	return en_landing_how_pick_title(inputs)
});